import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';

import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

const StyledLatestHundredPrescriptionRecordsText = styled.span`
   /* TODO: DREGAB-12222 - display i height do usunięcia po dodaniu przycisku */
   display: flex;
   align-items: center;
   flex: 1 0 32px;
   height: 32px;
   color: ${({ theme }) => theme.placeholder};
`;
StyledLatestHundredPrescriptionRecordsText.displayName = 'StyledLatestHundredPrescriptionRecordsText';

export const LatestHundredPrescriptionRecordsText = (): JSX.Element => {
   return (
      <StyledLatestHundredPrescriptionRecordsText>
         <Translate>
            {prescriptionsHistoryDownloadTranslationKeys.prescriptionsHistoryView.latestHundredPrescriptionsDisplayed}
         </Translate>
      </StyledLatestHundredPrescriptionRecordsText>
   );
};
